import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

const ANIMATION_STATES = {
    PAUSED: 0,
    RUNNING: 1,
    TERMINATE: 2
};

const ANIMATION_CONTROL = {
    PAUSE: 0,
    PLAY: 1,
    STOP: 2
};

function DaySelectCell({ value, onChange }) {
    return (
        <>
            <SelectCell value={value} onChange={onChange} options={DAYS.map((day, index) => ({ id: index, label: day }))} placeholder="- Choisir un jour -" />
        </>
    );
}

function Table({ headers, children }) {
    return (
        <table>
            <thead>
                <tr>
                    {headers && headers.map((header, index) => (
                        <th key={index}>{header}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                    {children}
            </tbody>
        </table>
    );
}

function EditDeleteCell({ onEdit, onDelete, change, disabled }) {
    return (
        <td>
            {change ? (
                <button className="button-edit" onClick={onEdit} disabled={disabled} >Modifier</button>
            ) : (
                <button className="button-delete" onClick={onDelete} disabled={disabled} >Supprimer</button>
            )}
        </td>
    );
}

function RedirectButtonCell({ text, redirectTo }) {
    let navigate = useNavigate();

    const onClick = (e) => {
        navigate(redirectTo);
    };

    return (
        <td>
            <button onClick={onClick}>{text}</button>
        </td>
    )
}

function AddButtonCell({ text="Ajouter", onAdd }) {
    return (
        <td>
            <button onClick={onAdd}>{text}</button>
        </td>
    )
}

function InputCell({ value, onChange, type = "text", min, placeholder = "" }) {
    return (
        <td>
            <input min={min} type={type} value={value} onChange={onChange} placeholder={placeholder} />
        </td>
    );
}

function SelectCell({value, onChange, options, disabled, placeholder = "- Sélectionner -" }) {
    return (
        <td>
            <select value={value} onChange={onChange} disabled={disabled}>
                <option value="" disabled>{placeholder}</option>
                {options.map((option, index) => (
                    <option value={option.id} key={option.id}>{option.label}</option>
                ))}
            </select>
        </td>
    );
}

function CheckboxCell({ value, onChange, options, disabled, keyId }) {

    return (
        <td>
            <Table headers={[]}>
                {options && options.map(option => (
                    <tr key={keyId+":"+option.id}>
                        <td>
                            <input type="checkbox" checked={value.indexOf(option.id+"")!==-1} onChange={onChange} value={option.id} id={keyId+":"+option.id} disabled={disabled} />
                            <label htmlFor={keyId+":"+option.id}>{option.label}</label>
                        </td>
                    </tr>
                ))}
            </Table>
        </td>
    )
}

function NewRowTemplate({ children }) {
    return (
        <tr className="new-row">
            {children}
        </tr>
    );
}

function TeacherColorCell({ name, color }) {
    const textColor = getContrastColor(color);

    return (
        <td style={{textAlign: "right", paddingRight: "1em"}}>
            <span style={{backgroundColor: color, padding: "0.25em", borderRadius: "0.25em", color: textColor}}>
                {name}
            </span>
        </td>
    )
}

function AnimatedComponent({ children, animatedElementRef, keyframes, defaultControl, options, onAnimationEnd = (e) => {} } ) {
    const animationContainterRef = useRef(animatedElementRef);
    const [animation, setAnimation] = useState();

    const [animationState, setAnimationState] = useState(ANIMATION_STATES.PAUSED);

    const play = () => {
        if(animationState === ANIMATION_STATES.PAUSED && animation !== undefined) {
            animation.play();
            setAnimationState(ANIMATION_STATES.RUNNING)
        }
    };

    const pause = () => {
        if(animation === undefined)
            return;

        animation.pause();
        setAnimationState(ANIMATION_STATES.PAUSED)
    };

    const onAnimationEnd0 = (e) => {
        setAnimationState(ANIMATION_STATES.TERMINATE);
        onAnimationEnd(e);
    };

    useEffect(() => {
        animationContainterRef.current = animatedElementRef.current;
    }, [animatedElementRef]);

    useEffect(() => {        
        if(keyframes !== undefined && options !== undefined) {
            if(options?.duration <= 0 || Number.isNaN(options?.duration)) {
                return;
            } 

            const newAnimation = animationContainterRef.current.animate(keyframes, options);

            if(defaultControl !== ANIMATION_CONTROL.PLAY) {
                newAnimation.pause();
                setAnimationState(ANIMATION_STATES.PAUSED);
            }
            
            newAnimation.onfinish = onAnimationEnd0;
            setAnimation(newAnimation);
        }
        
    }, [keyframes, options]);

    return (
        <>
            {children}
        </>
        
    );
}

function getContrastColor(hex) {
  hex = hex.replace("#", "");

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b);

  return luminance > 186 ? "#000000" : "#FFFFFF";
}


export {
    DAYS,
    ANIMATION_CONTROL,
    DaySelectCell,
    Table,
    EditDeleteCell,
    InputCell,
    SelectCell,
    NewRowTemplate,
    TeacherColorCell,
    getContrastColor,
    CheckboxCell,
    RedirectButtonCell,
    AddButtonCell,
    AnimatedComponent
}